import React from 'react';
import PropTypes from 'prop-types';
import ActiveLabel from "../../ActiveLabel";
import {I18nUtils} from "../../../../../i18n/I18nUtils";
import Arrays from "../../../utils/Arrays";
import nl2br from "../../../utils/nl2br";
import {OverlayTrigger, Popover} from "react-bootstrap";
import Button from "../../Button";

export default class WorkerTabRow extends React.Component {

  static renderHead(id, showOutsource = false, checkOptions = null ) { // checkOptions = { text = '', checked = false, onChecked = (checked) => {} }
    return(
      <tr>
        {
          checkOptions !== null ?
          <th className="check-export-delete">
            <input
              type="checkbox"
              className="filled-in chk-col-blue-grey"
              id={'worker-tab-row-header-' + id}
              checked={checkOptions.checked}
              onChange={({target}) => checkOptions.onChecked(target.checked)}
            />
            <label htmlFor={'worker-tab-row-header-' + id}><strong>{checkOptions.text}</strong></label>
          </th>
          : null
        }
        <th>{I18nUtils.tr('TR_ESTADO')}</th>
        <th>{I18nUtils.tr('TR_DNI_NIF')}</th>
        <th>{I18nUtils.tr('TR_NOMBRE')}</th>
        <th>{I18nUtils.tr('TR_APELLIDO_S')}</th>
        { showOutsource ? <th>{I18nUtils.tr('TR_SUBCONTRATA')}</th> : null }
        <th>{I18nUtils.tr('TR_OFICIO')}</th>
        <th>{I18nUtils.tr('TR_ESQUEMA')}</th>
      </tr>
    );
  }

  constructor(init){
    super(init);
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange({target}){
    this.props.actionSelectItem(this.props.worker, target.checked);
  }

  renderName(worker) {
    if (worker.error) {
      const popover = (
        <Popover id="popover-positioned-right" title="">{nl2br(worker.error)}</Popover>
      );
      return (
        <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={popover}>
          <span style={{ color: 'red'}}>{worker.name}</span>
        </OverlayTrigger>
      );
    }
    return worker.name;
  }

  render() {
    const { worker } = this.props;
    return (
      <tr>
        {
          this.props.selectedIds !== null ?
            <td className="check-export-delete">
              <input
                type="checkbox"
                id={'check-worker-' + worker.id}
                className="filled-in chk-col-blue-grey"
                onChange={this.handleChange}
                checked={Arrays.contains(this.props.selectedIds, this.props.worker.id)}
              />
              <label htmlFor={'check-worker-' + worker.id}>{this.props.selectText}</label>
            </td>
            : null
        }
        <td><ActiveLabel state={worker.worker_state}/></td>
        <td>{worker.dni}</td>
        <td><strong>{this.renderName(worker)}</strong></td>
        <td><strong>{worker.last_name}</strong></td>
        {this.props.showOutsource ? <td>{worker.company ? worker.company.name : ''}</td> : null}
        <td>{worker.position || ''}</td>
        <td>{worker.document_schema ? worker.document_schema.name : ''}</td>
        { this.props.action ?
          <Button text={this.props.actionText} className="btn-primary btn-sm btn-block" onClick={() => this.props.action(worker)} />
          : null }
      </tr>
    );
  }

}


WorkerTabRow.propTypes = {
  worker: PropTypes.objectOf(PropTypes.any).isRequired,

  selectedIds: PropTypes.array,
  actionSelectItem: PropTypes.func,
  selectText: PropTypes.string,
  showOutsource: PropTypes.bool,
  action: PropTypes.any,
  actionText: PropTypes.string,
};

WorkerTabRow.defaultProps = {
  showOutsource: false,
};



// WEBPACK FOOTER //
// ./src/app/shared/components/tabs/workers/WorkerTabRow.js